<template>
    <section class="check-pay">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div
                        class="check-pay__container d-flex flex-column align-items-center"
                    >
                        <template v-if="status === 'RESULT_SUCCESS'">
                            <div
                                class="
                  check-pay__card
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                "
                            >
                                <div
                                    class="check-pay__card-title text-center"
                                    v-html="statusText"
                                ></div>
                                <div class="check-pay__card-comment d-flex align-items-end">
                                    <div class="check-pay__card-target d-flex">
                                        <div class="check-pay__card-avatar" v-if="petAvatar">
                                            <img :src="petAvatar" alt=""/>
                                        </div>
                                        <div class="check-pay__card-avatar" v-if="userAvatar">
                                            <img :src="userAvatar" alt=""/>
                                        </div>
                                    </div>
                                    <div class="check-pay__card-text">
                                        {{ thankMsg }}
                                    </div>
                                </div>
                                <button
                                    type="button"
                                    class="btn modal-button"
                                    data-toggle="modal"
                                    data-target="#leaveComment"
                                >
                                    Написать волонтёру
                                </button>
                                <div class="check-pay__card-actions">
                                    <a href="/catalog" class="btn">Каталог животных</a>
                                    <a href="/">Вернуться к ленте</a>
                                </div>

                            </div>

                            <div class="check-pay__promo">
                                <div class="check-pay__promo-heading text-center">
                                    Вам подарок!
                                </div>

                                <div class="check-pay__promo-item d-flex">
                                    <div
                                        class="
                      check-pay__promo-left
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                                    >
                                        <img src="/assets/images/icons/21vek.svg" alt=""/>
                                    </div>
                                    <div class="check-pay__promo-right">
                                        <div class="check-pay__promo-title">
                                            Промокод в интернет-гипермаркет 21vek.by
                                        </div>
                                        <div class="check-pay__promo-text">
                                            <strong>5%</strong> скидки на зоотовары.<br/>
                                            <strong>3%</strong> скидки на остальной ассортимент.
                                        </div>
                                        <div
                                            class="
                        check-pay__promo-actions
                        d-flex
                        justify-content-between
                      "
                                        >
                                            <div class="check-pay__promo-code">
                                                <strong>SUTHX</strong>
                                                <span
                                                    class="check-pay__copy"
                                                    @click.prevent="copyCode('SUTHX')"
                                                ><img src="/assets/images/icons/copy.svg" alt=""
                                                /></span>
                                            </div>
                                            <a href="/">Подробнее</a>
                                        </div>
                                    </div>
                                </div>

                                <template v-if="promocodes.length">
                                    <template v-for="item in promocodes">
                                        <div
                                            class="check-pay__promo-item d-flex"
                                            v-if="item.campaign === 'dominos_june_2021'"
                                            :key="item.id"
                                        >
                                            <div
                                                class="
                          check-pay__promo-left
                          d-flex
                          justify-content-center
                          align-items-center
                        "
                                            >
                                                <img
                                                    src="/assets/images/partners/dominos_logo.png"
                                                    alt=""
                                                />
                                            </div>
                                            <div class="check-pay__promo-right">
                                                <div class="check-pay__promo-title">
                                                    Ваш персональный промокод в пиццерии Domino's:
                                                </div>
                                                <div class="check-pay__promo-text">
                                                    Скидка <strong>-30%</strong> на пиццу любого размера и
                                                    вида основы при заказе онлайн с доставкой или в
                                                    пиццерии.
                                                </div>
                                                <div
                                                    class="
                            check-pay__promo-actions
                            d-flex
                            justify-content-between
                          "
                                                >
                                                    <div class="check-pay__promo-code">
                                                        <strong>{{ item.code }}</strong>
                                                        <span
                                                            class="check-pay__copy"
                                                            @click.prevent="copyCode(item.code)"
                                                        ><img src="/assets/images/icons/copy.svg" alt=""
                                                        /></span>
                                                    </div>
                                                    <a
                                                        href="https://dominos.by/?utm_source=saveus"
                                                        target="_blank"
                                                    >Подробнее</a
                                                    >
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="check-pay__promo-item d-flex"
                                            :key="item.id"
                                            v-else
                                        >
                                            <div
                                                class="
                          check-pay__promo-left
                          d-flex
                          justify-content-center
                          align-items-center
                        "
                                            >
                                                <img src="/assets/images/icons/21vek.svg" alt=""/>
                                            </div>
                                            <div class="check-pay__promo-right">
                                                <div class="check-pay__promo-title">
                                                    Промокод в интернет-гипермаркет 21vek.by
                                                </div>
                                                <div class="check-pay__promo-text">
                                                    <strong>5%</strong> скидки на зоотовары.<br/>
                                                    <strong>3%</strong> скидки на остальной ассортимент.
                                                </div>
                                                <div
                                                    class="
                            check-pay__promo-actions
                            d-flex
                            justify-content-between
                          "
                                                >
                                                    <div class="check-pay__promo-code">
                                                        <strong>SUTHX</strong>
                                                        <span
                                                            class="check-pay__copy"
                                                            @click.prevent="copyCode('SUTHX')"
                                                        ><img src="/assets/images/icons/copy.svg" alt=""
                                                        /></span>
                                                    </div>
                                                    <a href="/">Подробнее</a>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </template>

                        <template v-else>
                            <div
                                class="
                  check-pay__card
                  d-flex
                  flex-column
                  justify-content-center
                  align-items-center
                "
                            >
                                <div
                                    class="check-pay__card-title text-center"
                                    v-html="statusText"
                                ></div>
                                <div class="check-pay__card-actions">
                                    <a href="/catalog" class="btn">Каталог животных</a>
                                    <a href="/">Вернуться к ленте</a>
                                </div>

                            </div>
                        </template>
                        <a href="/" class="btn btn--home">Вернуться на главную</a>
                    </div>
                </div>
            </div>
        </div>
        <div
            class="modal fade"
            id="leaveComment"
            tabindex="-1"
            role="dialog"
            aria-labelledby="leaveCommentTitle"
            aria-hidden="true"
        >
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLongTitle">
                            Оставить комментарий
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <textarea v-model="form.comment" rows="10"></textarea>
                    </div>
                    <div class="modal-footer">
                        <button
                            @click.prevent="saveMsg"
                            type="button"
                            class="btn btn-primary"
                            :disabled="!form.comment.length"
                        >
                            Отправить
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "CheckPayPageComponent",
    props: {
        id: {},
        name: {},
        type: {},
        city: {},
        amount: {},
        tips: {},
        petAvatar: {},
        userAvatar: {},
        statusText: {},
        trackingId: {},
        alfaResult: {
            type: String,
            required: true,
        },
        thankMsg: {
            type: String,
            required: true,
        },
        data: {
            type: Object,
            required: false,
            default: () => {
            },
        },
    },
    data() {
        return {
            a: "d",
            status: this.alfaResult === "success" ? "RESULT_SUCCESS" : "RESULT_DECLINED",
            /*            statusText:
                            this.alfaResult === "success"
                                ? "30 BYN<br> отправлено Белле"
                                : "Упс...Что-то пошло не так :(",*/
            promocodes: this.data?.promocodes ?? [],
            countOfChecks: 0,
            form: {
                comment: "",
            },
        };
    },

    mounted() {
        $("#leaveComment").on("hidden.bs.modal", function () {
            document.body.style.paddingRight = 0;
        });

        if (this.alfaResult === "success") {
            window.dataLayer = window.dataLayer || [];

            if (this.tips > 0) {
                dataLayer.push({ ecommerce: null });
                dataLayer.push({
                    event: 'purchase',
                    saveusincome: this.tips,
                    ecommerce: {
                        transaction_id: this.trackingId,
                        value: this.amount,
                        currency: "BYN",
                        items: [
                            {
                                item_id: this.id,   //ID можно взять из ссылки
                                item_name: this.name,
                                item_brand: this.type, //Dog, Kitten, Puppy
                                // item_category: "girl", // boy
                                item_category2: this.city,  //город, откуда живтоное.
                            }
                        ]
                    }
                });
            } else {
                dataLayer.push({
                    event: 'purchase',
                    saveusincome: this.amount,
                    type: 'one_time'
                });
            }

        }
    },

    methods: {
        async saveMsg() {
            if (this.form.comment) {
                let params = {
                    commentable_type: this.data.commentable.commentable_type || null,
                    commentable_id: this.data.commentable.commentable_id || null,
                    reply_comment_id: null,
                    text: this.form.comment,
                };

                try {
                    const {data: {success} = {success: false} /*default data*/} =
                        await axios.post("/api/comments", params);

                    if (success) {
                        location.href = `/${this.data.commentable.commentable_type}s/${this.data.commentable.commentable_id}`;
                    }
                } catch (_e) {
                    console.log(_e);
                    alert(
                        "Произошла ошибка! Попробуйте обновить страницу и попробовать еще раз"
                    );
                }
            }
        },
        copyCode(code) {
            var el = document.createElement('textarea');
            el.value = code;
            el.setAttribute('readonly', '');
            el.style = {position: 'absolute', left: '-9999px'};
            document.body.appendChild(el);
            el.select();
            document.execCommand('copy');
            document.body.removeChild(el);
        },
    },
};
</script>

<style lang="scss" scoped>
.check-pay {
    background-color: #e3e3e3;

    &__copy {
        cursor: pointer;
    }

    .container {
        background: url("/assets/images/icons/promo-cat.svg") no-repeat 15px bottom/100px;

        @media screen and(max-width: 768px) {
            background-image: none;
        }

    }

    .btn {
        padding: 10px 30px;
        border-radius: 45px;
        font-weight: 700;
        font-size: 12px;
        width: max-content;
        transition: opacity 0.2s ease;
        color: #fff;

        &:hover {
            opacity: 0.8;
        }


        @media screen and (max-width: 768px) {
            border-radius: 8px;
        }

    }

    .modal {
        &-button {
            border: 1px solid #ffffff;
            background: transparent;
        }
    }

    &__container {
        padding: 50px 0;
        width: 100%;
        max-width: 540px;
        margin: 0 auto;
    }

    &__card {
        padding: 50px;
        background: #96cf5b url("/assets/images/check-pay-dekstop.png") no-repeat center/contain;
        margin-bottom: 30px;
        min-height: 350px;
        border-radius: 3px;
        width: 100%;

        &-title {
            color: #fff;
            font-size: 30px;
            line-height: 32px;
            font-weight: 600;
            margin-bottom: 40px;
        }

        &-target {
            margin-right: 10px;
            flex-shrink: 0;
        }

        &-avatar {
            border: 3px solid #7bb73e;
            border-radius: 50%;
            overflow: hidden;

            img {
                display: inline-block;
                width: 40px;
                height: 40px;
                background: #aaa;
            }

            & + .check-pay__card-avatar {
                margin-left: -15px;
            }

            @media screen and(max-width: 768px) {
                &:first-child {
                    display: none;
                }
            }

        }

        &-text {
            position: relative;
            padding: 12px 16px;
            background: #fff;
            border-radius: 16px;
            font-size: 15px;
            line-height: 22px;
            color: #333;

            &::after {
                position: absolute;
                display: block;
                content: "";
                left: -4px;
                bottom: 0;
                height: 20px;
                width: 15px;
                background: url("/assets/images/icons/triangle.svg") no-repeat center/cover;
            }
        }

        &-comment {
            margin-bottom: 20px;
        }

        &-actions {
            display: none;
            margin-top: auto;

            a {
                display: block;
                margin: 15px 0;
                color: #fff;
                text-align: center;
            }

        }

        @media screen and (max-width: 768px) {
            padding: 50px 25px;
            min-height: 100vh;
            min-width: 100vw;
            background-size: cover;
            background-image: url("/assets/images/check-pay-bg.png");

            &-title {
                margin-top: auto;
            }

            &-actions {
                display: block;
            }

        }

    }

    &__promo {
        margin-bottom: 30px;

        &-heading {
            font-size: 18px;
            font-weight: 600;
            line-height: 22px;
            margin-bottom: 20px;
        }

        &-left {
            width: 110px;
            padding: 0 10px;
            border-right: 1px solid #dae2ec;

            img {
                max-width: 100%;
            }
        }

        &-right {
            padding: 8px 20px;
        }

        &-title {
            margin-bottom: 20px;
            font-weight: 600;
        }

        &-text {
            margin-bottom: 16px;
        }

        @media screen and(max-width: 768px) {
            &-left {
                border: none;
                width: 100%;
                margin-bottom: 10px;
            }

            &-right {
                padding: 8px;
            }
        }

        &-item {
            position: relative;
            font-size: 14px;
            position: relative;
            width: 100%;
            background: #fff;
            border-radius: 15px;
            padding: 16px;
            margin-bottom: 20px;

            &::before,
            &::after {
                position: absolute;
                display: block;
                content: "";
                top: 50%;
                width: 32px;
                height: 32px;
                transform: translateY(-50%);
                background: #e3e3e3;
            }

            &::before {
                left: 0;
                clip-path: circle(50% at left center);
            }

            &::after {
                right: 0;
                clip-path: circle(50% at right center);
            }

            @media screen and(max-width: 768px) {
                flex-direction: column;
            }

        }

    }

}
</style>
